import React, { useEffect, useState } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useParams } from "react-router-dom";
import { useApiClient } from "../../../api";
import GeneralLoading from "../../../shared-components/Loading";
import {
  Box,
  Card,
  CardContent,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { InformationSnippet } from "../../../shared-components/InformationSnippet";
import { FruitifyUserSearch } from "../components/FruitifyUserSearch";
import SchoolSearchAutocomplete from "../../school/components/SchoolSearchAutocomplete";
import { SchoolSummary } from "./Schools";

const SchoolGroupQuickSummary = ({ schoolGroup }) => {
  return (
    <Card data-testid={`school-group-summary-${schoolGroup.id}`}>
      <CardContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h3">{schoolGroup.name}</Typography>
        </Stack>

        <Grid container spacing={2} direction={"row"} sx={{ mt: 2, mb: 2 }}>
          <Grid size={3}>
            <InformationSnippet
              title={"Number of Schools"}
              value={schoolGroup.schoolCount}
            />
          </Grid>
          <Grid size={3}>
            <InformationSnippet
              title={"Subscribed Schools"}
              value={schoolGroup.subscribedSchoolsCount || 0}
            />
          </Grid>
          <Grid size={3}>
            <InformationSnippet
              title={"Teachers"}
              value={schoolGroup.teachersCount || 0}
            />
          </Grid>
          <Grid size={3}>
            <InformationSnippet
              title={"Students"}
              value={schoolGroup.studentsCount || 0}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default function SchoolGroupView() {
  const { id } = useParams();
  const ApiClient = useApiClient();
  const [loading, setLoading] = useState(true);
  const [schoolGroup, setSchoolGroup] = useState({});

  useEffect(() => {
    fetchSchoolGroup();
  }, [id]);

  const fetchSchoolGroup = async () => {
    setLoading(true);
    try {
      const response = await ApiClient.schools.getSchoolGroup({
        schoolGroup: id,
      });
      if (response) {
        setSchoolGroup(response.schoolGroup);
      }
    } catch (error) {
      console.error("Failed to fetch school group", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <GeneralLoading />;
  }

  // TODO: show schools (use school search with group as a param)
  return (
    <FruitifyContainer>
      <Stack spacing={2}>
        <SchoolGroupQuickSummary schoolGroup={schoolGroup} />

        <SchoolSearchAutocomplete
          subscriptionSwitch
          showResults
          schoolGroup={schoolGroup}
        >
          {({ options, page, pageInfo, handlePageChange }) => (
            <>
              <Grid container spacing={4} sx={{ mt: 2 }}>
                {options.map((school) => (
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 3 }}
                    key={school.id}
                    sx={{ display: "flex" }}
                  >
                    <SchoolSummary school={school} />
                  </Grid>
                ))}
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={pageInfo.hasNextPage ? page + 1 : page}
                  page={page}
                  onChange={handlePageChange}
                />
              </Box>
            </>
          )}
        </SchoolSearchAutocomplete>
        <FruitifyUserSearch
          showTitle
          hideSubscriptionStatus
          allowSelect
          allowEmailStatusFilter
          schoolGroup={schoolGroup}
          teacherOnly
        />
      </Stack>
    </FruitifyContainer>
  );
}

export { SchoolGroupView };
